import { useFormik } from 'formik';
import { TeamOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import TeamSelectField from 'views/templates/components/TeamSelectField';

type Props = {
    open: boolean;
    onConfirm: (teamId: string) => void;
    onSkip: () => void;
    onClose: () => void;
};

const AssignTeamToProductModal = ({ open, onConfirm, onSkip, onClose }: Props) => {
    const formik = useFormik({
        initialValues: {
            teamId: null,
        },
        onSubmit: () => undefined,
    });

    return (
        <ConfirmationModal
            open={open}
            width={560}
            icon={<TeamOutlined />}
            title="Assign Team"
            destroyOnClose
            onCancel={onSkip}
            onClose={onClose}
            onConfirm={() => {
                const teamId = formik.values.teamId;
                if (!teamId) return;
                onConfirm(teamId);
            }}
            cancelButtonText="Skip Team Assignment"
            confirmButtonText="Assign"
            confirmationButtonDisabled={!Boolean(formik.values.teamId)}
            content={
                <div style={{ width: '100%' }}>
                    <TeamSelectField
                        fieldProps={formik.getFieldProps('teamId')}
                        fieldMeta={formik.getFieldMeta('teamId')}
                        fieldHelper={formik.getFieldHelpers('teamId')}
                    />
                </div>
            }
        />
    );
};

export default AssignTeamToProductModal;
